module.exports = "<div *ngIf=\"APIISNOTRESPONDING\" fxLayoutAlign=\"center center\" [style.margin.em]=\"2\">\r\n    <span> {{ serverNotRespondingText }} </span> \r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/shared/server-not-responding/server-not-responding.component.html
// module id = ./src/app/login/shared/server-not-responding/server-not-responding.component.html
// module chunks = main